import { FC, ReactNode } from 'react';

import clsx from 'clsx';

import { ToastProps } from './types';

import styles from './styles.module.scss';

import SuccessIcon from '@/assets/icons/done.svg?react';
import ErrorIcon from '@/assets/icons/error.svg?react';
import WarningIcon from '@/assets/icons/warning.svg?react';

const ICON_STYLE_MAP: Record<ToastProps['type'], string> = {
  error: styles.iconError,
  warning: styles.iconWarning,
  success: styles.iconSuccess,
};

const ICON_MAP: Record<ToastProps['type'], ReactNode> = {
  success: <SuccessIcon />,
  error: <ErrorIcon />,
  warning: <WarningIcon />,
};

export const ToastNotification: FC<ToastProps> = ({ title, message, type }) => {
  return (
    <div className={clsx(styles.toastContainer, styles[type])}>
      <div className={ICON_STYLE_MAP[type]}>{ICON_MAP[type]}</div>

      <div>
        <p className={styles.title}>{title}</p>
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
};
